import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AttributeRows from "@kaspernj/api-maker/build/bootstrap/attribute-rows"
import memo from "set-state-compare/build/memo"
import React from "react"
import {SchoolClass} from "models"
import setLayout from "shared/set-layout"
import {useFrontLayout} from "components/front-layout"
import useModel from "@kaspernj/api-maker/build/use-model"
import {useParams} from "@kaspernj/api-maker/build/router/route"

/** @typedef {object} RoutesUserSchoolClassesShowProps */

/** @typedef {object} RoutesUserSchoolClassesShowState */

/**
 * @extends {ShapeComponent<RoutesUserSchoolClassesShowProps, RoutesUserSchoolClassesShowState>}
 */
class RoutesUserSchoolClassesShow extends ShapeComponent {
  setup() {
    setLayout("user")

    const params = useParams()
    const {schoolClass, schoolClassNotFound} = useModel(SchoolClass, {
      abilities: {
        SchoolClass: ["invite"]
      },
      match: {params},
      select: {
        SchoolClass: ["createdAt", "id", "interpretedName", "name", "schoolId", "updatedAt"]
      }
    })

    this.schoolClass = schoolClass
    this.schoolClassNotFound = schoolClassNotFound

    useFrontLayout()?.setState({
      headerTitle: schoolClass?.interpretedName(),
      schoolClass
    })
  }

  render() {
    const {schoolClass} = this.tt

    return (
      <div className="routes--user--school-classes--show">
        {schoolClass &&
          <AttributeRows attributes={["name", "createdAt", "updatedAt"]} model={schoolClass} />
        }
      </div>
    )
  }
}

export default memo(shapeComponent(RoutesUserSchoolClassesShow))
